'use client';

import React from 'react';
import {useI18n, Language} from '@udemy-v2/i18n';
import {Icon} from '@udemy-v2/icons';
import styles from './course-language.module.scss';
import classNames from 'classnames';

export interface CourseLanguagesProps {
    courseLocale?: string;
}

/**
 * CourseLanguages displays the primary language of the course
 */
export const CourseLanguage: React.FC<CourseLanguagesProps> = ({courseLocale}) => {
    const {gettext} = useI18n();

    return (
        <div
            className={classNames(styles['course-languages'], 'ud-text-sm')}
            data-purpose="course-language"
        >
            <Icon
                glyph="language"
                size="xsmall"
                color="subdued-inverted"
                label={false}
                role="img"
                aria-label={gettext('Course Language')}
                aria-hidden={false}
            />
            <span>
                <Language locale={courseLocale ?? ''} />
            </span>
        </div>
    );
};
